import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { InstrumentoFormularioHost } from '../models/instrumento-formulario-host.interface';

@Component({
  selector: 'app-instrumento-avaliacao-modal',
  templateUrl: './instrumento-avaliacao-modal.component.html',
  styleUrls: ['./instrumento-avaliacao-modal.component.scss']
})
export class InstrumentoAvaliacaoModalComponent {
  @Input() vm!: InstrumentoFormularioHost;

  @ViewChild('notaMinimaInput') notaMinimaInput?: ElementRef<HTMLInputElement>;
  @ViewChild('notaMaximaInput') notaMaximaInput?: ElementRef<HTMLInputElement>;
  @ViewChild('pesoInput') pesoInput?: ElementRef<HTMLInputElement>;

  focusField(campo: 'notaMinima' | 'notaMaxima' | 'peso'): void {
    let input: ElementRef<HTMLInputElement> | undefined;

    if (campo === 'notaMinima') {
      input = this.notaMinimaInput;
    } else if (campo === 'notaMaxima') {
      input = this.notaMaximaInput;
    } else if (campo === 'peso') {
      input = this.pesoInput;
    }

    if (input?.nativeElement) {
      input.nativeElement.focus();
    }
  }


}
